import { fetchActionFactory } from '../../../shared/store/fetchFactory';
import {
  FETCH_SCENARIOS_OPTIONS,
  FETCH_COUNTRIES_FOR_SCENARIO,

  FETCH_SCENARIO_MEMBERS_DATA,
  FETCH_SCENARIO_MEMBERS_DATA_SUCCESS,
  FETCH_SCENARIO_MEMBERS_DATA_FAILURE,

  CLEAR_SCENARIO_MEMBERS_DATA,
} from './types';
import {
  fetchScenarioMembersCompareData as fetchScenarioMembersCompareDataApi,
  fetchScenarioMembersData as fetchScenarioMembersDataApi,
} from '../api';

import {
  fetchScenarios as fetchScenariosApi,
  fetchCountries as fetchCountriesApi,
} from '../../shared/api';

import { errorNotification } from '../../../shared/store/notificationActions';
import { fetchingError } from '../../../shared/store/actions';
import { zipObject } from '../../shared/utils';

export const fetchScenariosOptions = fetchActionFactory(
  FETCH_SCENARIOS_OPTIONS,
  fetchScenariosApi,
  {
    field: 'scenarios',
  }
);

export const fetchMembersWithData = fetchActionFactory(
  FETCH_SCENARIO_MEMBERS_DATA,
  fetchScenarioMembersDataApi,
  {
    field: 'scenarioMembersData',
  }
);

export const fetchScenarioMembersWithData = ({ reportsNames, scenarioId, companyCode, reportingCurrency }) =>
  async dispatch => {
    dispatch({ type: CLEAR_SCENARIO_MEMBERS_DATA });
    dispatch({ type: FETCH_SCENARIO_MEMBERS_DATA });

    const membersData = await Promise.all(reportsNames.map(reportName => fetchScenarioMembersDataApi({
      scenarioId,
      companyCode,
      reportingCurrency,
      reportName,
    })));

    try {
      dispatch({
        type: FETCH_SCENARIO_MEMBERS_DATA_SUCCESS,
        scenarioMembersData: zipObject(reportsNames, membersData),
      });
    } catch (error) {
      dispatch({ type: FETCH_SCENARIO_MEMBERS_DATA_FAILURE });

      if (error.isFetchingError) {
        dispatch(fetchingError(error.message));
        dispatch(errorNotification(error.message));
        return;
      }

      throw error;
    }
  };

export const fetchScenarioMembersWithComparingData = ({
  reportsNames,
  scenarioId,
  compareScenarioId,
  companyCode,
  reportingCurrency,
}) =>
  async dispatch => {
    dispatch({ type: FETCH_SCENARIO_MEMBERS_DATA });

    const membersData = await Promise.all(reportsNames.map(reportName => fetchScenarioMembersCompareDataApi({
      scenarioId,
      companyCode,
      reportingCurrency,
      reportName,
      compareScenarioId,
    })));

    try {
      dispatch({
        type: FETCH_SCENARIO_MEMBERS_DATA_SUCCESS,
        scenarioMembersData: zipObject(reportsNames, membersData),
      });
    } catch (error) {
      dispatch({ type: FETCH_SCENARIO_MEMBERS_DATA_FAILURE });

      if (error.isFetchingError) {
        dispatch(fetchingError(error.message));
        dispatch(errorNotification(error.message));
        return;
      }

      throw error;
    }
  };

export const fetchCountries = fetchActionFactory(
  FETCH_COUNTRIES_FOR_SCENARIO,
  fetchCountriesApi,
  {
    field: 'countries',
  }
);
